/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_End_Other_Retry_FailedInputs */

const en_us2_offline_end_other_retry_failed = /** @type {(inputs: Offline_End_Other_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The other workout was ended, but this one was not sent yet. Tap Try again.`)
};

const pt_br2_offline_end_other_retry_failed = /** @type {(inputs: Offline_End_Other_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O outro treino foi encerrado, mas este ainda não foi enviado. Toque em Tentar de novo.`)
};

const es_419_offline_end_other_retry_failed = /** @type {(inputs: Offline_End_Other_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El otro entrenamiento se terminó, pero este aún no se envió. Toca Reintentar.`)
};

const pt_pt2_offline_end_other_retry_failed = /** @type {(inputs: Offline_End_Other_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O outro treino foi terminado, mas este ainda não foi enviado. Toca em Tentar outra vez.`)
};

const fr_fr2_offline_end_other_retry_failed = /** @type {(inputs: Offline_End_Other_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'autre séance a été terminée, mais celle-ci n'est pas encore envoyée. Touche Réessayer.`)
};

const de_de2_offline_end_other_retry_failed = /** @type {(inputs: Offline_End_Other_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das andere Training wurde beendet, dieses aber noch nicht gesendet. Tippe auf „Erneut versuchen“.`)
};

const it_it2_offline_end_other_retry_failed = /** @type {(inputs: Offline_End_Other_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'altro allenamento è stato chiuso, ma questo non è ancora stato inviato. Tocca Riprova.`)
};

/**
* | output |
* | --- |
* | "The other workout was ended, but this one was not sent yet. Tap Try again." |
*
* @param {Offline_End_Other_Retry_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_end_other_retry_failed = /** @type {((inputs?: Offline_End_Other_Retry_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_End_Other_Retry_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_end_other_retry_failed(inputs)
	if (locale === "es-419") return es_419_offline_end_other_retry_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_end_other_retry_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_end_other_retry_failed(inputs)
	if (locale === "de-DE") return de_de2_offline_end_other_retry_failed(inputs)
	if (locale === "it-IT") return it_it2_offline_end_other_retry_failed(inputs)
	return en_us2_offline_end_other_retry_failed(inputs)
});
export { offline_end_other_retry_failed as "offline.end_other_retry_failed" }